import styles from "styles-to-js-loader/styles"
import { fetchTrendData, formatData } from "../common/FetchFilterData"
import WC from "../common/WebcomponentCreator/src"
import FilterFactory from "../common/FilterFactory"
import "../css/ballsNew.css"

const filterEventName = "newBallFilterSubmit"
const filterUrl =
    "https://app.vantetider.se/spa/1.1/rest/filters/filterchoices/availabilityfilter"

const MESSAGES = {
    LOADING: "Laddar...",
    NO_DATA: "Ingen data"
}

const BALL_CONFIGS = [
    {
        url: "https://app.vantetider.se/spa/1.1/rest/availableHealthcareSpeciLatest/medianProdFirst",
        unit: "dagar",
        name: "Väntetid första kontakt",
        text: "Medianen är [value] dagar för <b>[date]</b>"
    },
    {
        url: "https://app.vantetider.se/spa/1.1/rest/availableHealthcareSpeciLatest/medianProdOperation",
        unit: "dagar",
        name: "Väntetid operation/åtgärd",
        text: "Medianen är [value] dagar för <b>[date]</b>"
    },
    {
        url: "https://app.vantetider.se/spa/1.1/rest/availableHealthcareSpeciLatest/intimeProdReturnVisits",
        unit: "%",
        name: "Återbesök i tid",
        text: "[value]% har fått vård inom medicinskt måldatum i <b>[date]</b>"
    },
    {
        url: "https://app.vantetider.se/spa/1.1/rest/availableHealthcareSpeciLatest/intimeProdEmergency",
        unit: "%",
        name: "Tid på akuten",
        text: "[value]% har fått vård inom 4 timmar i <b>[date]</b>"
    }
]

class WaitOverviewBalls extends WC {
    constructor() {
        const template = document.createElement("form")
        super(template, { shadowMode: "closed" })
        this.getShadow().appendChild(styles.get())

        this.filterDiv = document.createElement("div")
        template.appendChild(this.filterDiv)

        this.ballsDiv = document.createElement("div")
        this.ballsDiv.setAttribute("class", "coverage-items")
        template.appendChild(this.ballsDiv)

        this.ballsObj = {}

        this.regionSelect = new FilterFactory("select", {}, {})
        this.filterDiv.appendChild(this.regionSelect)
        this.loadData()

        this.regionSelect.addEventListener("change", () => {
            this.dispatchSubmitEvent()
        })

        // Create ball structure once
        this.createBallStructure()
        this.updateBallsData()

        this.filterSubmitHandler = (e) => {
            const params = e.detail
            this.cleanupFilterParams(params.values)
            this.updateBallsData(params)
        }

        document.addEventListener(filterEventName, this.filterSubmitHandler, {
            capture: true
        })

        // Add debounced resize listener to re-sync title heights
        this.resizeTimeout = null
        this.resizeHandler = () => {
            clearTimeout(this.resizeTimeout)
            this.resizeTimeout = setTimeout(() => {
                this.syncTitleHeights()
            }, 150)
        }
        window.addEventListener("resize", this.resizeHandler)
    }

    cleanupFilterParams(values) {
        for (const key in values) {
            if (values[key] === "-1") delete values[key]
        }
    }

    createKeyValueElement() {
        const div = document.createElement("div")
        div.className = "keyValue"
        div.innerHTML =
            '<span class="value">-</span><span class="subtext"></span>'
        return div
    }

    createBallStructure() {
        // Create all ball DOM elements once
        BALL_CONFIGS.forEach((config) => {
            const temp = document.createElement("div")
            temp.className = "coverage"
            const title = document.createElement("p")
            title.className = "title"
            title.innerHTML = config.name.toUpperCase()
            const ball = document.createElement("div")
            ball.className = "ball"
            const bg = document.createElement("div")
            bg.className = "background"
            const keyValue = this.createKeyValueElement()
            const extra = document.createElement("div")
            extra.className = "extra"
            const breadText = document.createElement("p")
            breadText.className = "text"
            breadText.innerHTML = MESSAGES.LOADING
            temp.appendChild(title)
            temp.appendChild(ball)
            ball.appendChild(bg)
            ball.appendChild(keyValue)
            temp.appendChild(extra)
            extra.appendChild(breadText)

            this.ballsObj[config.name.toUpperCase()] = {
                element: temp,
                keyValue: keyValue,
                breadText: breadText,
                title: title
            }
            this.ballsDiv.appendChild(temp)
        })
        // Sync title heights after a brief delay to ensure rendering is complete
        setTimeout(() => this.syncTitleHeights(), 0)
    }

    syncTitleHeights() {
        const titles = Object.values(this.ballsObj).map((b) => b.title)
        titles.forEach((t) => (t.style.height = "auto"))
        const maxHeight = Math.max(...titles.map((t) => t.offsetHeight))
        titles.forEach((t) => (t.style.height = `${maxHeight}px`))
    }

    async updateBallsData(params = null) {
        this.setLoadingState()
        const header = params?.values || {}

        const ballPromises = BALL_CONFIGS.map(async (config) => {
            try {
                const res = await fetchTrendData(config.url, header, "series")
                const data = res?.series?.[0]?.data

                if (!data?.length) {
                    console.warn(`No data available for ${config.name}`)
                    return this.updateBallUI(
                        config.name,
                        null,
                        MESSAGES.NO_DATA
                    )
                }

                const filterItem = data.at(-1)
                const date = this.getDateString(res.startDate)
                const displayText = filterItem.y
                    ? config.text
                          .replace("[value]", filterItem.y)
                          .replace("[date]", `${date.month} ${date.year}`)
                    : MESSAGES.NO_DATA

                this.updateBallUI(
                    config.name,
                    filterItem.y,
                    displayText,
                    config.unit
                )
            } catch (error) {
                console.error(`Error fetching data for ${config.name}:`, error)
                this.updateBallUI(config.name, null, MESSAGES.NO_DATA)
            }
        })

        await Promise.allSettled(ballPromises)
        this.syncTitleHeights()
    }

    setLoadingState() {
        Object.values(this.ballsObj).forEach((ball) => {
            ball.keyValue.querySelector(".value").textContent = "-"
            ball.keyValue.querySelector(".subtext").textContent = ""
            ball.breadText.innerHTML = MESSAGES.LOADING
            ball.element.style.opacity = "0.5"
        })
    }

    updateBallUI(name, value, text, unit = "") {
        const ball = this.ballsObj[name.toUpperCase()]
        if (!ball) return

        const valueEl = ball.keyValue.querySelector(".value")
        const subtextEl = ball.keyValue.querySelector(".subtext")

        if (value != null) {
            valueEl.textContent = value
            subtextEl.textContent = unit
            if (unit.length === 1) {
                ball.keyValue.classList.add("inline-unit")
            } else {
                ball.keyValue.classList.remove("inline-unit")
            }
        } else {
            valueEl.textContent = "-"
            subtextEl.textContent = ""
            ball.keyValue.classList.remove("inline-unit")
        }

        ball.breadText.innerHTML = text
        ball.element.style.opacity = "1"
    }

    getDateString(dateStr = "", showNationell = false) {
        const [year, monthNum] = dateStr.split("-")

        if (showNationell) {
            return {
                year,
                month: monthNum <= 6 ? "våren" : "hösten"
            }
        }

        const months = [
            "januari",
            "februari",
            "mars",
            "april",
            "maj",
            "juni",
            "juli",
            "augusti",
            "september",
            "oktober",
            "november",
            "december"
        ]
        return {
            year,
            month: months[parseInt(monthNum) - 1] || ""
        }
    }

    async loadData() {
        const allRegionsOption = {
            name: "Alla regioner",
            value: -1
        }
        try {
            const res = await formatData({}, filterUrl)
            this.regions = [allRegionsOption, ...res.regions]

            new FilterFactory("options", this.regions, {}).forEach((o) => {
                this.regionSelect.appendChild(o)
            })
        } catch (error) {
            console.error("Failed to load regions:", error)
            // Add default option even if API fails
            const defaultOption = new FilterFactory(
                "options",
                [allRegionsOption],
                {}
            )
            defaultOption.forEach((o) => this.regionSelect.appendChild(o))
        }
    }

    dispatchSubmitEvent() {
        this.dispatchEvent(
            new CustomEvent(filterEventName, {
                bubbles: true,
                composed: true,
                detail: {
                    values: { regionId: this.regionSelect.value },
                    text: {
                        regions:
                            this.regionSelect.options[
                                this.regionSelect.selectedIndex
                            ].text
                    }
                }
            })
        )
    }

    disconnectedCallback() {
        document.removeEventListener(
            filterEventName,
            this.filterSubmitHandler,
            {
                capture: true
            }
        )
        window.removeEventListener("resize", this.resizeHandler)
        clearTimeout(this.resizeTimeout)
    }
}

if (!customElements.get("wait-overview-balls")) {
    WC.define("wait-overview-balls", WaitOverviewBalls)
}
